import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let task = new BaseTableModule('/ws/task/');

const state = {
    ...task.state,
};
const getters = {
    ...task.getters,
};
const actions = {
    ...task.actions,
};
const mutations = {
    ...task.mutations,
};

export default {
    modules: {
        BaseTask: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}